import { globalLegendConfiguration, globalTickStyles } from '../ChartsGlobalConfiguration'

const mapToWholeMonth = (shortMonth: string) => {
  const mL = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const mS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
  return mL[mS.findIndex(el => el === shortMonth)]
}

export const tournamentChartoptions = {
  maintainAspectRatio: false,
  scales: {
    xAxes: [
      {
        ticks: {
          minor: globalTickStyles,
          padding: 5,
        },
        gridLines: {
          display: false,
          color: '#ffffff',
        },
      },
    ],
    yAxes: [
      {
        ticks: {
          minor: globalTickStyles,
          beginAtZero: true,
          min: 0,
          max: 10,
          stepSize: 1,
          padding: 20,
        },
        gridLines: {
          color: '#dadce0',
          display: true,
          drawBorder: false,
          zeroLineColor: '#dadce0',
        },
      },
    ],
  },
  tooltips: {
    titleSpacing: 6,
    xPadding: 20,
    yPadding: 20,
    textAlign: 'left',
    backgroundColor: '#16234C',
    titleFontColor: '#ffffff',
    titleFontSize: 12,
    titleFontFamily: 'Poppins',
    titleFontStyle: '300',
    titleAlign: 'center',
    bodyFontColor: '#ffffff',
    bodyFontSize: 12,
    bodyFontFamily: 'Poppins',
    bodyFontStyle: 'bold',
    footerFontFamily: 'Poppins',
    footerFontSize: 12,
    footerFontStyle: 'normal',
    footerFontColor: '#ffffff',
    mode: 'index',
    callbacks: {
      title: function (tooltipItems) {
        return mapToWholeMonth(tooltipItems[0].xLabel)
      },
      footer: function (tooltipItem) {
        return `${tooltipItem[0].value} wins  |  ${tooltipItem[1].value} losses`
      },
      label: function (tooltipItem, data) {
        return null
      },
    },
  },
  legend: globalLegendConfiguration,
}
